// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import IRoute from '../interfaces/IRoute';
import { BrandIdentity, Home, ProductDesign, UIUX } from '../pages';

const routes: IRoute[] = [
  {
    path: '/',
    name: 'Home Page',
    component: Home,
    exact: true,
  },
  {
    path: '/brand-identity',
    name: 'Brand Identity',
    component: BrandIdentity,
    exact: true,
  },
  {
    path: '/product-design',
    name: 'Product Design',
    component: ProductDesign,
    exact: true,
  },
  {
    path: '/ui-ux-design',
    name: 'Product Design',
    component: UIUX,
    exact: true,
  },
];

export default routes;
